
import {pushmap} from "../router/pushmap";

const routergo={
  // computed:{
  //   ...mapGetters(['menuList']),
  //
  // },

  methods:{
    $routerGo(params){
      if(!pushmap[params.name]){
        this.$router.push(params)
      }
      else {
        let obj=pushmap[params.name]
        let trans={
          ...params,
          name:obj.to,
        }
        if(obj.targetTab) {
          !trans.params && (trans.params = {})
          trans.params.targetTab=obj.targetTab
        }
        this.$router.push(trans)

      }

    },


  }

}

export {routergo}
